<template>
  <div class="monitoring-cabin-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="clickAdd" title="新增" size="mini"
                     type="primary" icon="el-icon-plus">新增
          </el-button>
          <el-button @click="clickEdit" title="编辑" size="mini"
                     type="primary" icon="el-icon-edit">编辑
          </el-button>
          <el-button @click="setLocation" size="mini"
                     type="primary" icon="el-icon-location">设置定位
          </el-button>
          <el-button @click="del" size="mini"
                     type="primary" icon="el-icon-delete">删除
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="编号"></el-table-column>
        <el-table-column label="所属船舱总段"></el-table-column>
        <el-table-column label="所属甲板" prop="deck.name"></el-table-column>
        <el-table-column label="所属分站"></el-table-column>
        <el-table-column label="所属过道" prop="passage.name"></el-table-column>
        <el-table-column label="所属舱室"></el-table-column>
        <!--<el-table-column label="是否设置定位">-->
          <!--<template slot-scope="scope">-->
            <!--<el-button v-if="scope.row.points[0].x!=0" size="mini" type="primary" plain>已设置</el-button>-->
            <!--<el-button v-if="scope.row.points[0].x==0" size="mini" type="warning">未设置</el-button>-->
          <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
    </div>

    <div class="pagination pt-10 t-center">
      <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                     :page-size="pagination.size" :page-sizes="[20,40,80,160]"
                     :current-page.sync="pagination.page"
                     :total="pagination.total" @size-change="changeSize"
                     @current-change="changeCurrent"></el-pagination>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">编号</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">船舱总段</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择船舱总段">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">所在甲板</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择甲板">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">所在分站</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择分站">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">所在过道</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择过道">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">所在舱室</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择舱室">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="dialog-map" title="设置基站座标、以及到过道的路线" width="80%" :visible.sync="setPointDialogIsShow">
      <div style="width:100%;height:400px;">
        <v-ship-map-set-area ref="shipmap" @transmit="transmit"
                             containerHeight="400"
                             :shipMapData="dataToMap"
                             :ship_img="ship_img">
        </v-ship-map-set-area>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="emptyData">清空</el-button>
        <el-button size="mini" type="primary" @click="submitPassagePoint">保存</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script type="text/ecmascript-6">
  import {api} from '../../common/js/api.js';
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  import {mock} from '../../common/js/mock2.js';
  import ShipMapSetArea from '../../components/ship-map-set-area.vue';
  export default {
    data() {
      return {
        ship_img: {
          url: '',
          width: 0,
          height: 0
        },
        setPointDialogIsShow: false,
        dataToMap: {},
        dataFromMap: {},
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 20,
          total: 0
        },
        tableLoading: false,
        addobj: {name: ""},
        addDialogShow: false
      };
    },

    computed: {},

    created() {
      this.getData();
      this.ship_img.width = 5000;
      this.ship_img.height = 1815;
      this.ship_img.url = '1111';
    },

    methods: {
      submitPassagePoint(){
        console.log(this.dataFromMap);
        alert('保存数据');
        this.setPointDialogIsShow = false;
      },

      transmit(data){
        console.log(JSON.stringify(data));
        this.dataFromMap = data;
      },

      emptyData(){
        this.$refs.shipmap.emptyData();
      },

      setLocation(){
        console.log(this.currentRow);
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.setPointDialogIsShow = true;
        this.dataToMap = {
          type: 'setBaseStation',
          data: {
            id: this.currentRow.id,
            direction: this.currentRow.direction,
            points: this.currentRow.points
          }
        };
        console.log(this.dataToMap);
        setTimeout(() => {
          this.$refs.shipmap.load();
        }, 10);
      },

      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },
      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.addDialogShow = true;
      },
      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      },
      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
      },
      getData(flag) {
        let obj = {page: this.pagination.page - 1, limit: this.pagination.size};
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.list = mock.station;
        //this.tableLoading = true;
        return;
        api.station.list(obj).then((res) => {
          console.log(res);
          this.tableLoading = false;
          this.pagination.total = res.total;
          this.list = res.data;
        })
      },
      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },
      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {
      'v-ship-map-set-area': ShipMapSetArea
    }
  };
</script>

<style lang="less" rel="stylesheet/less">
  .monitoring-cabin-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
  }
</style>
